




































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { MenuService } from "@/services/menu-service";
import vuedraggable from "vuedraggable";
import { Utils } from "@/services/utils";
import { ElForm } from "element-ui/types/form";
import { Action } from "vuex-class";

@Component({
  components: {
    draggable: vuedraggable
  }
})
export default class MenuAuthority extends Vue {
  @Prop({ default: "" })
  title: string;
  menuService: MenuService = new MenuService();
  menuList: any = [];
  isEdit: boolean = false;
  drag: boolean = false;
  isShowDialog: boolean = false;
  timerSaveOrder: any = false;
  util: Utils = new Utils();
  routeList: string[] = [];
  newMenu: any = {};
  editIndex: number = -1;
  loading = true;

  rules = {
    adminMenuNm: [{ validator: this.validationName, trigger: "blur" }],
    route: [{ validator: this.validationRoute, trigger: "change" }]
  };

  $refs!: {
    addForm: ElForm;
  };

  @Action("setState", { namespace: "Menu" })
  setState: any;

  validationName(rule: any, value: string, callback: any) {
    if (value === "") {
      callback(new Error("Please input menu name."));
    } else {
      callback();
    }
  }
  validationRoute(rule: any, value: string, callback: any) {
    if (value === "") {
      callback(new Error("Please select route name."));
    } else {
      callback();
    }
  }

  created() {
    this.getMenuList();
  }

  async getMenuList() {
    this.loading = true;
    const res = await this.menuService.getMenu();
    if (res) {
      // const sortingBase = [1, 10, 200, 100];
      // const menuList = res.map((e: any) => {
      //   const authority =  e.authority.sort((a: any, b: any) => {
      //     return sortingBase.indexOf(a.loginKbn) - sortingBase.indexOf(b.loginKbn);
      //   });
      //   return {...e, authority};
      // });
      // this.menuList = menuList;
      this.menuList = res;
      this.setState(res);
    }
    this.loading = false;
  }

  onDragEnd(event: any) {
    this.drag = false;
    if (this.timerSaveOrder) {
      clearTimeout(this.timerSaveOrder);
      this.timerSaveOrder = null;
    }
    this.timerSaveOrder = setTimeout(() => {
      this.menuList = this.menuList.map((e: any, i: number) => {
        return { ...e, displayOrder: i + 1 };
      });
      let data = this.mapDataForUpdate();
      this.onUpdateInsertMenu(data);
    }, 1000);
  }

  mapDataForUpdate() {
    let data = this.util.deepCopy(this.menuList);
    data = data.map((e: any) => {
      delete e.authority;
      return e;
    });
    return data;
  }

  onSave() {
    this.menuService.saveMenuAuthority(this.menuList).then((res: any) => {
      if (res == 200) {
        this.updateSidebar();
        this.$message({
          message: "save successful",
          type: "success"
        });
      } else {
        this.$message.error("エラー");
      }
    });
  }

  onUpdateInsertMenu(data: any, isAdd: boolean = false) {
    this.menuService.updateInsertMenu(data).then((res: any) => {
      if (res == 200) {
        if (isAdd) {
          this.getMenuList();
        } else if (this.isEdit) {
          this.menuList[this.editIndex].adminMenuNm = this.newMenu.adminMenuNm;
          this.isEdit = false;
          this.editIndex = -1;
        }
        this.updateSidebar();
      } else if (res != 200) {
        this.$message.error("エラー");
      }
    });
  }

  onShowDialog(i: number = -1) {
    if (i > -1) {
      this.isEdit = true;
      this.editIndex = i;
      this.newMenu = this.util.deepCopy(this.menuList[i]);
      delete this.newMenu.authority;
    } else {
      this.isEdit = false;
      this.newMenu = {
        adminMenuNm: "",
        route: "",
        displayOrder: this.menuList.length
      };
      let router: any = this.$router;
      let routeListNow = this.menuList.map((e: any) => e.route);
      let routeList = router.options.routes[0].children.filter(
        (e: any) => routeListNow.indexOf(e.name) == -1 && e.name != "home"
      );
      this.$set(this, "routeList", routeList);
    }

    this.isShowDialog = true;
  }

  onSaveNewMenu() {
    this.$refs.addForm.validate((valid: boolean) => {
      if (valid) {
        this.isShowDialog = false;
        this.onUpdateInsertMenu([this.newMenu], true);
      }
    });
  }

  updateSidebar() {
    this.$emit("updateSidebar");
  }

  onDialogOpened() {
    this.$refs.addForm.clearValidate();
  }

  onCloseDialog() {
    this.$refs.addForm.clearValidate();
    this.isShowDialog = false;
  }

  onClearName() {
    this.$refs.addForm.clearValidate();
  }

  beforeDestroy() {
    if (this.timerSaveOrder) {
      this.onUpdateInsertMenu(this.mapDataForUpdate());
      clearTimeout(this.timerSaveOrder);
    }
  }
}
